import { isTrackingRejected } from "./consent";

declare global {
  interface Window {
    twq?: (
      command: "config" | "track" | "event",
      ...args: unknown[]
    ) => void;
  }
}

export function trackXPixelPageView(): void {
  if (typeof window === "undefined") return;
  // 拒否済みなら送信しない: 読み込み済みの uwt.js は拒否後も生き続けるため、
  // 送信側で止める（X Pixel には GA4 の ga-disable に相当する公式手段がない）
  if (isTrackingRejected()) return;
  // try/catch でラップする理由: 一部のadblockerが window.twq を throw するゲッターで置き換えるため、
  // typeof チェック自体や呼び出しが例外を投げる可能性がある
  try {
    const twq = window.twq;
    if (typeof twq !== "function") return;
    twq("track", "PageView");
  } catch {
    // adblocker等によるエラーは握りつぶす（広告計測は best-effort）
  }
}
